import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import { h as H } from "./sizes-DktS74Qp.mjs";
import { f } from "./index-LyFokDcn.mjs";
import { l as g } from "./lodash-5ofSKtz3.mjs";
import _, { useRef as L, useEffect as K, memo as le, Fragment as P, createContext as de, useState as ce, useContext as ue, createElement as pe, Component as fe, Children as me } from "react";
import { F as he } from "./file-dropper-iCPDh7on.mjs";
import { L as v } from "./layout-box-DFBM-kSI.mjs";
import { F as Q } from "./flex-Cc3osQLf.mjs";
import { a as z } from "./index-isgVnOkQ.mjs";
import { m as w } from "./tss-DN0acMKN.mjs";
import { M as J, d as X } from "./constants-CnFYFetN.mjs";
import { P as ge } from "./progress-bar-RdhhxBEI.mjs";
import { u as ye } from "./index-B1qvqCCQ.mjs";
import { F as Fe, f as be } from "./file-icon-DTzfQjIh.mjs";
import { c as _e } from "./index-DkZ16bcJ.mjs";
import { I as W } from "./icon-button-BxDvkq_l.mjs";
import { I as xe } from "./CircleX14x14-Dx82f2vj.mjs";
import { _ as ee } from "./composeRefs-YONvD-rx.mjs";
import { S as we } from "./status-message-BMoS1d1Y.mjs";
import { g as Ie } from "./get-aria-describedby-G1wcWKF2.mjs";
import { I as je } from "./icon-v2-DGtVEk7e.mjs";
import { B as ve } from "./body-text-BiQwh5-U.mjs";
import { D as ke } from "./divider-Dq5lrAFK.mjs";
import { T as q } from "./text-button-yPCa43NP.mjs";
import { B as G } from "./button-CUHBhgeQ.mjs";
import { S as Be } from "./index-CoZFka0j.mjs";
import { d as Ee, f as Re, k as Te } from "./keys-CQjWNUL0.mjs";
const te = (t) => _.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 20", width: "16", height: "20" }, t),
  _.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    _.createElement("path", { d: "M2,0 L10,0 L10,6 L16,6 L16,18 C16,19.1045695 15.1045695,20 14,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z M2,8 L2,18 L14,18 L14,8 L2,8 Z M12,0 L16,4 L12,4 L12,0 Z M5,10 L11,10 C11.5522847,10 12,10.4477153 12,11 L12,15 C12,15.5522847 11.5522847,16 11,16 L5,16 C4.44771525,16 4,15.5522847 4,15 L4,11 C4,10.4477153 4.44771525,10 5,10 Z" })
  )
);
te.displayName = "FileUnknownBlack16x20";
const ne = (t) => _.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, t),
  _.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    _.createElement(
      "g",
      { fillRule: "nonzero" },
      _.createElement("path", { d: "M1460.4735,824.776833 L1459,830 L1464.22317,828.5265 L1470.07692,822.67275 L1466.32725,818.923083 L1460.4735,824.776833 Z M1472.223,816.777 C1471.7225,816.275917 1471.05633,816 1470.34817,816 C1469.64,816 1468.97383,816.275917 1468.47333,816.777 L1467.15383,818.0965 L1470.9035,821.846167 L1472.223,820.526667 C1472.72408,820.026167 1473,819.36 1473,818.651833 C1473,817.943083 1472.72408,817.2775 1472.223,816.777 Z", transform: "translate(-1459 -816)" })
    )
  )
);
ne.displayName = "Pencil14x14";
function $e(t, e = []) {
  const n = L(!0);
  K(() => {
    n.current || t(), n.current = !1;
  }, e);
}
function Me(t, e = []) {
  $e(() => {
    if (t && t.current) {
      const n = t.current, i = { bubbles: !0, cancelable: !0 };
      n.dispatchEvent(new Event("input", i)), n.dispatchEvent(new Event("change", i));
    }
  }, e);
}
const Le = le((t) => {
  const { fileIds: e, inputRef: n, isDisabled: i = !1, name: r } = t, s = L();
  return Me(s, [JSON.stringify(e)]), /* @__PURE__ */ a.jsxs(P, { children: [
    /* @__PURE__ */ a.jsx(
      "input",
      {
        disabled: i,
        name: r,
        ref: ee(s, n),
        type: "hidden",
        value: e[0] ? e[0] : ""
      }
    ),
    e.slice(1).map((o) => /* @__PURE__ */ a.jsx("input", { disabled: i, name: r, type: "hidden", value: o }, o))
  ] });
});
function Pe(t = []) {
  return t.reduce((e, n) => {
    const i = g.uniqueId();
    return e[i] = n, e;
  }, {});
}
function Ce(t = !1) {
  return window.jQuery ? t ? $.__("No files selected") : $.__("No file selected") : t ? "No files selected" : "No file selected";
}
function Se(t = !1) {
  return window.jQuery ? t ? f.ifFeature("encore", $.__("Choose Files"), $.__("Choose File(s)")) : $.__("Choose File") : t ? f.ifFeature("encore", "Choose Files", "Choose File(s)") : "Choose File";
}
function ie(t) {
  return {
    name: t.name,
    type: t.type,
    size: t.size
  };
}
function Ue(t) {
  return new Promise((e, n) => {
    const i = [];
    Promise.all(t.map((r) => r.catch((s) => i.push(s)))).then(() => {
      e(i);
    }, n);
  });
}
function De(t, e) {
  return t.map((n) => e.get(n));
}
function Ne(t, e) {
  return t.reduce((n, i) => {
    const r = e.get(i);
    return r && (n[r] = ie(i)), n;
  }, {});
}
function Oe(t = []) {
  return t.reduce((e, n) => {
    const i = g.uniqueId();
    return e.set(n, i), e;
  }, /* @__PURE__ */ new WeakMap());
}
function Qe(t, e, n) {
  return g.difference(e, n).map((r) => {
    const s = t[r];
    return s && s.id ? s.id : void 0;
  }).filter((r) => typeof r == "string" || typeof r == "number");
}
function ze(t) {
  return new Promise((e, n) => {
    const i = new FileReader();
    i.readAsArrayBuffer(t), i.onload = function() {
      new Blob([i.result], { type: "application/pdf" }).text().then((s) => {
        const o = s.includes("Encrypt") || s.substring(s.lastIndexOf("<<"), s.lastIndexOf(">>")).includes("/Encrypt");
        e(o);
      }).catch((s) => {
        n(new DOMException("Problem parsing input file: ", s));
      });
    }, i.onerror = () => {
      i.abort(), n(new DOMException("Problem reading input file."));
    };
  });
}
const Ae = w()(({ palette: t, typography: e }) => ({
  root: {
    alignItems: "center",
    display: "flex"
  },
  placeholderIcon: {
    display: "inline-block",
    fill: t.gray[700],
    lineHeight: 0,
    marginLeft: "10px",
    marginRight: "5px"
  },
  placeholderText: {
    display: "inline-block",
    color: t.gray[700],
    fontSize: e.fabricFontSize("medium")
  }
})), He = (t) => {
  const { biId: e, buttonRef: n, buttonText: i, canSelectMultiple: r, isDisabled: s, isRequired: o, hasFiles: l, onBlur: p, onClick: u } = t, { classes: d } = Ae(), c = window.jQuery ? $.__("Add Files") : "Add Files", m = i || Se(r), h = Ce(r);
  return /* @__PURE__ */ a.jsx("div", { className: d.root, "data-fabric-component": "FileUploadToggle", children: l ? f.ifFeature(
    "encore",
    /* @__PURE__ */ a.jsxs(v, { marginTop: 0.5, width: "100%", children: [
      /* @__PURE__ */ a.jsx(ke, { color: "neutral-extra-weak", marginY: 1, orientation: "horizontal" }),
      /* @__PURE__ */ a.jsx(
        q,
        {
          "data-bi-id": e ? `${e}-add-files-button` : "",
          disabled: s,
          onBlur: p,
          onClick: u,
          ref: n,
          size: "small",
          startIcon: "up-from-line-regular",
          type: "button",
          children: c
        }
      )
    ] }),
    /* @__PURE__ */ a.jsx(
      q,
      {
        clickAction: u,
        "data-bi-id": e ? `${e}-add-files-button` : "",
        isDisabled: s,
        text: `+ ${c}`,
        type: "button"
      }
    )
  ) : f.ifFeature(
    "encore",
    /* @__PURE__ */ a.jsxs(Q, { alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ a.jsxs(
        G,
        {
          "data-bi-id": e ? `${e}-choose-files-button` : "",
          disabled: s,
          onBlur: p,
          onClick: u,
          ref: n,
          startIcon: "up-from-line-regular",
          type: "button",
          variant: "outlined",
          children: [
            m,
            o && "*"
          ]
        }
      ),
      /* @__PURE__ */ a.jsxs(Q, { alignItems: "center", gap: 1, children: [
        /* @__PURE__ */ a.jsx(je, { color: "neutral-extra-extra-strong", name: "file-lines-regular", size: 16 }),
        /* @__PURE__ */ a.jsx(ve, { color: "neutral-extra-strong", children: h })
      ] })
    ] }),
    /* @__PURE__ */ a.jsxs(P, { children: [
      /* @__PURE__ */ a.jsx(
        G,
        {
          clickAction: u,
          "data-bi-id": e ? `${e}-choose-files-button` : "",
          isDisabled: s,
          outline: !0,
          text: m,
          type: "button"
        }
      ),
      /* @__PURE__ */ a.jsx("div", { className: d.placeholderIcon, children: /* @__PURE__ */ a.jsx(te, { "aria-hidden": "true", role: "presentation" }) }),
      /* @__PURE__ */ a.jsx("div", { className: d.placeholderText, children: h })
    ] })
  ) });
}, A = de({
  acceptedTypes: [],
  allFileIds: [],
  canRename: !1,
  canSelectMultiple: !1,
  filesById: {},
  isDisabled: !1,
  onBlur: () => null,
  pendingFileIds: [],
  progressByFileId: {},
  removeFile: () => null,
  renameFile: () => null,
  status: void 0,
  statusMessageId: "",
  toggleRef: void 0,
  upload: () => null
}), We = w()((t) => {
  const { mode: e } = t;
  return {
    root: {
      display: "inline-block",
      outline: e === J.Dye ? `2px solid ${X.main}` : void 0,
      position: "relative",
      width: f.ifFeature("encore", "100%")
    },
    input: {
      height: 0,
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      width: 0
    }
  };
}), V = (t) => {
  const {
    id: e,
    renderToggle: n = (y) => /* @__PURE__ */ a.jsx(He, { ...y })
  } = t, [i, r] = ce(!1), { classes: s } = We(), o = L(), l = L(null), {
    ariaDescribedby: p,
    acceptedTypes: u = [],
    allFileIds: d = [],
    biId: c = "",
    canSelectMultiple: m,
    errorMessage: h,
    filesById: F,
    inputRef: C,
    isDisabled: x = !1,
    isRequired: B,
    name: S,
    onBlur: E,
    pendingFileIds: R = [],
    status: b,
    statusMessageId: I,
    toggleRef: U,
    upload: D,
    warningMessage: T
  } = ue(A), N = () => {
    o.current && o.current.click();
  }, O = (y) => {
    const se = y.relatedTarget !== null, ae = document.activeElement !== y.currentTarget;
    typeof E == "function" && (se || ae) && E();
  }, M = d.length > 0 && !m, j = b === "error" && h || b === "warning" && T;
  return K(() => {
    i || r(!0), i && l.current && l.current.focus();
  }, [d.length]), /* @__PURE__ */ a.jsxs(P, { children: [
    M ? null : /* @__PURE__ */ a.jsxs("div", { className: s.root, "data-fabric-component": "FileUploadInput", children: [
      n({
        biId: c,
        buttonRef: ee(l, U),
        canSelectMultiple: m,
        hasFiles: d.length > 0,
        isDisabled: x,
        isRequired: B,
        onBlur: O,
        onClick: N
      }),
      /* @__PURE__ */ a.jsx(
        "input",
        {
          accept: u == null ? void 0 : u.join(","),
          "aria-describedby": Ie(j ? I : void 0, p),
          "aria-invalid": b === "error",
          "aria-label": "file-input",
          className: s.input,
          "data-bi-id": `${c}-file-input`,
          disabled: x,
          id: e,
          multiple: m,
          onChange: (y) => {
            D([...y.currentTarget.files]);
          },
          ref: o,
          required: B && !d.length,
          tabIndex: -1,
          type: "file"
        }
      ),
      j && /* @__PURE__ */ a.jsx(v, { marginTop: 1, children: /* @__PURE__ */ a.jsx(
        we,
        {
          id: I,
          message: b === "error" ? h : T,
          showIcon: !0,
          status: b
        }
      ) })
    ] }),
    /* @__PURE__ */ a.jsx(
      Le,
      {
        fileIds: Qe(F, d, R),
        inputRef: C,
        isDisabled: x,
        name: S
      }
    )
  ] });
}, qe = w()(({ constructs: t, borderRadiuses: e, gradients: n, palette: i }) => ({
  root: f.ifFeature(
    "encore",
    {
      backgroundColor: t.surface.neutral.weak,
      borderRadius: e[1e3],
      height: "4px",
      width: "100%"
    },
    {
      backgroundColor: i.gray[300],
      height: "3px",
      width: "100%"
    }
  ),
  progress: {
    background: f.ifFeature("encore", i.primary.main, n.lighterToLightestLinear(i.primary)),
    borderRadius: f.ifFeature("encore", e[1e3]),
    display: "block",
    height: "100%",
    transition: "width 100ms"
  }
})), Ge = (t) => {
  const { progress: e = 0 } = t, { classes: n } = qe();
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      "aria-label": "file-upload-progress-bar",
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuenow": e,
      className: n.root,
      role: "progressbar",
      children: /* @__PURE__ */ a.jsx("div", { className: n.progress, style: { width: `${e}%` } })
    }
  );
}, Ve = w()(({ constructs: t, palette: e, spacing: n, typography: i }, { isPending: r }) => ({
  root: {
    alignItems: "center",
    display: "flex",
    fontSize: f.ifFeature("encore", i.medium.fontSize),
    gap: f.ifFeature("encore", n(1.5)),
    lineHeight: f.ifFeature("encore", i.medium.lineHeight),
    marginBottom: f.ifFeature("encore", void 0, "10px"),
    minHeight: f.ifFeature("encore", "32px"),
    "&:last-child": {
      marginBottom: f.ifFeature("encore", void 0, 0)
    }
  },
  name: {
    color: f.ifFeature(
      "encore",
      r ? t.text.neutral.weak : t.text.neutral.strong,
      e.gray[r ? 500 : 800]
    ),
    fontWeight: f.ifFeature("encore", i.fontWeightMedium)
  },
  icon: {
    lineHeight: "0",
    marginRight: f.ifFeature("encore", "-4px", "8px")
  },
  actionIcon: {
    cursor: "pointer",
    fill: e.gray[600],
    lineHeight: 0,
    marginLeft: f.ifFeature("encore", "4px", "8px"),
    "&:active, &:hover": {
      fill: e.gray[800]
    }
  }
})), Ye = (t) => {
  const {
    biId: e,
    canRename: n,
    canRemove: i = !0,
    classes: r,
    isPending: s,
    file: o,
    progress: l,
    onRemove: p,
    onRename: u,
    temporaryId: d
  } = t, { classes: c } = Ve({ isPending: s }), { palette: m } = ye();
  return /* @__PURE__ */ a.jsxs("div", { className: c.root, children: [
    /* @__PURE__ */ a.jsx("span", { className: c.icon, children: /* @__PURE__ */ a.jsx(Fe, { ariaHidden: !0, customFill: s ? m.gray[500] : void 0, filename: o.name }) }),
    /* @__PURE__ */ a.jsx("span", { className: _e(c.name, r == null ? void 0 : r.name), children: o.name }),
    n ? f.ifFeature(
      "encore",
      /* @__PURE__ */ a.jsx(
        W,
        {
          "aria-label": window.jQuery ? $.__("edit filename") : "edit filename",
          "data-bi-id": e ? `${e}-rename-button` : "",
          icon: "pen-solid",
          noBoundingBox: !0,
          onClick: () => {
            u(o, d);
          },
          size: "extra-small",
          type: "button"
        }
      ),
      /* @__PURE__ */ a.jsx(
        "span",
        {
          "aria-label": window.jQuery ? $.__("edit filename") : "edit filename",
          className: c.actionIcon,
          "data-bi-id": e ? `${e}-rename-button` : "",
          onClick: () => {
            u(o, d);
          },
          onKeyDown: (h) => {
            h.key === "Enter" && u(o, d);
          },
          role: "button",
          tabIndex: 0,
          children: /* @__PURE__ */ a.jsx(ne, { role: "presentation" })
        }
      )
    ) : null,
    i ? f.ifFeature(
      "encore",
      /* @__PURE__ */ a.jsx(
        W,
        {
          "aria-label": window.jQuery ? $.__("remove file") : "remove file",
          "data-bi-id": e ? `${e}-removed-button` : "",
          icon: "circle-xmark-solid",
          noBoundingBox: !0,
          onClick: () => {
            p(d);
          },
          size: "extra-small",
          type: "button"
        }
      ),
      /* @__PURE__ */ a.jsx(
        "span",
        {
          "aria-label": window.jQuery ? $.__("remove file") : "remove file",
          className: c.actionIcon,
          "data-bi-id": e ? `${e}-removed-button` : "",
          onClick: () => {
            p(d);
          },
          onKeyDown: (h) => {
            h.key === "Enter" && p(d);
          },
          role: "button",
          tabIndex: 0,
          children: /* @__PURE__ */ a.jsx(xe, { role: "presentation" })
        }
      )
    ) : null,
    l && l < 100 ? f.ifFeature(
      "encore",
      /* @__PURE__ */ a.jsx(v, { marginLeft: 0.5, children: /* @__PURE__ */ a.jsx(ge, { current: l, height: 4, total: 100, width: "100px" }) }),
      /* @__PURE__ */ a.jsx(v, { marginLeft: 1.25, width: "92px", children: /* @__PURE__ */ a.jsx(Ge, { progress: l }) })
    ) : null
  ] });
}, Ze = w()((t) => {
  const { mode: e } = t;
  return {
    root: {
      outline: e === J.Dye ? `2px solid ${X.main}` : void 0
    }
  };
}), Y = ({ itemProps: t }) => {
  const { classes: e } = Ze();
  return /* @__PURE__ */ a.jsx(A.Consumer, { children: ({
    allFileIds: n = [],
    biId: i,
    canRename: r,
    filesById: s = {},
    isDisabled: o = !1,
    pendingFileIds: l = [],
    progressByFileId: p = {},
    removeFile: u = g.noop,
    renameFile: d = g.noop
  }) => n.length === 0 ? null : /* @__PURE__ */ a.jsx("div", { className: e.root, "data-fabric-component": "FileUploadList", children: n.map((c) => {
    const m = s[c], h = g.includes(l, c), F = p[c];
    return /* @__PURE__ */ pe(
      Ye,
      {
        biId: i,
        canRemove: !o,
        canRename: r,
        file: m,
        isPending: h,
        ...t,
        key: c,
        onRemove: u,
        onRename: d,
        progress: F,
        temporaryId: c
      }
    );
  }) }) });
}, Ke = window.jQuery ? $.__("One or more files failed to upload.") : "One or more files failed to upload.", Je = window.jQuery ? $.__("One or more files failed to upload for the following reasons:") : "One or more files failed to upload for the following reasons:";
var k = {};
(function(t) {
  var e, n = Ee, i = Re, r = Te;
  n(t, "__esModule", {
    value: !0
  });
  var s = be;
  i(e = r(s)).call(e, function(o) {
    o === "default" || o === "__esModule" || o in t && t[o] === s[o] || n(t, o, {
      enumerable: !0,
      get: function() {
        return s[o];
      }
    });
  });
})(k);
function Xe(t) {
  return (e) => {
    const n = t[e] || {}, i = n.nativeFile;
    let r = "";
    switch (n.errorType) {
      case "network_failure":
        r = window.jQuery ? $.__("Something went wrong with the network connection. Please give it another try.") : "Something went wrong with the network connection. Please give it another try.";
        break;
      case "storage_space_exceeded":
        r = window.jQuery ? $.__(
          "You can't upload any more files because you are over your plan's storage limit. Get in touch with your BambooHR administrator for help."
        ) : "You can't upload any more files because you are over your plan's storage limit. Get in touch with your BambooHR administrator for help.";
        break;
      case "invalid_file_type":
        r = window.jQuery ? $.__(
          'We can’t accept the ".%s" file format. Make sure you’re selecting the right file(s) and try again.',
          k.getExtFromFileName(i.name)
        ) : `We can’t accept the ".${k.getExtFromFileName(
          i.name
        )}" file format. Make sure you’re selecting the right file(s) and try again.`;
        break;
      case "invalid_file_size":
        r = window.jQuery ? $.__("The maximum file size you can upload is 20 MB.") : "The maximum file size you can upload is 20 MB.";
        break;
      case "only_previewable_file_type":
        r = window.jQuery ? $.__("Make sure you’re only trying to upload the file types specified.") : "Make sure you’re only trying to upload the file types specified.";
        break;
      case "unknown_error":
        r = window.jQuery ? $.__("Something on our side prevented your file(s) from uploading. Please give it another try.") : "Something on our side prevented your file(s) from uploading. Please give it another try.";
        break;
      case "backup_company":
        r = window.jQuery ? $.__("You can't upload files on a backup.") : "You can't upload files on a backup.";
        break;
      default:
        r = n.message;
    }
    return r;
  };
}
function et(t, e) {
  return g.uniq(t.map(Xe(e)).filter((n) => !!n));
}
const tt = w()(() => ({
  reasons: {
    listStyleType: "disc",
    marginLeft: "25px",
    marginTop: "4px"
  }
})), nt = (t) => {
  const { failedFileIds: e = [], failuresByFileId: n = {} } = t, i = et(e, n), { classes: r } = tt();
  return /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx("div", { children: i.length > 0 ? Je : Ke }),
    i.length ? /* @__PURE__ */ a.jsx("ul", { className: r.reasons, children: i.map((s) => /* @__PURE__ */ a.jsx("li", { children: s }, s)) }) : null
  ] });
};
function it(t = [], e) {
  const [n] = t, i = e[n] || {}, r = i.nativeFile, s = window.jQuery ? $.__("Whoops, something on our side prevented your file from uploading. Please give it another try.") : "Whoops, something on our side prevented your file from uploading. Please give it another try.";
  let o = "";
  switch (i.errorType) {
    case "network_failure":
      o = window.jQuery ? $.__("For some reason we are having trouble uploading files right now. Please give it another try in a few minutes.") : "For some reason we are having trouble uploading files right now. Please give it another try in a few minutes.";
      break;
    case "storage_space_exceeded":
      o = window.jQuery ? $.__(
        `Uploading the file "%s" would cause you to exceed your plan's storage limit. Get in touch your BambooHR administrator for help.`,
        r.name
      ) : `Uploading the file "${r.name}" would cause you to exceed your plan's storage limit. Get in touch your BambooHR administrator for help.`;
      break;
    case "invalid_file_type":
      o = window.jQuery ? $.__(
        'Sorry, we can’t accept the ".%s" file format. Make sure you’re selecting the right file and try again.',
        k.getExtFromFileName(r.name)
      ) : `Sorry, we can’t accept the ".${k.getExtFromFileName(
        r.name
      )}" format. Make sure you’re selecting the right file and try again.`;
      break;
    case "invalid_file_size":
      o = window.jQuery ? $.__("Whoa, this is a big file (a little too big). The maximum file size you can upload is 20 MB.") : "Whoa, this is a big file (a little too big). The maximum file size you can upload is 20 MB.";
      break;
    case "invalid_file_size_empty":
      o = window.jQuery ? $.__("Unable to upload an empty file. Are you sure you selected the correct file?") : "Unable to upload an empty file. Are you sure you selected the correct file?";
      break;
    case "only_previewable_file_type":
      o = window.jQuery ? $.__("Make sure you’re only trying to upload the file types specified.") : "Make sure you’re only trying to upload the file types specified.";
      break;
    case "unknown_error":
      o = s;
      break;
    case "backup_company":
      o = window.jQuery ? $.__("You can't upload files on a backup.") : "You can't upload files on a backup.";
      break;
    case "encrypted_pdf_not_allowed":
      o = window.jQuery ? $.__("Encrypted PDFs are not allowed.") : "Encrypted PDFs are not allowed.";
      break;
    default:
      o = i.message || s;
  }
  return o;
}
const rt = (t) => {
  const { failedFileIds: e, failuresByFileId: n } = t;
  return /* @__PURE__ */ a.jsx("div", { children: it(e, n) });
}, ot = (t) => {
  const { canSelectMultiple: e, failedFileIds: n = [], failuresByFileId: i = {}, isVisible: r = !1, onDismiss: s } = t, o = e ? /* @__PURE__ */ a.jsx(nt, { failedFileIds: n, failuresByFileId: i }) : /* @__PURE__ */ a.jsx(rt, { failedFileIds: n, failuresByFileId: i });
  return /* @__PURE__ */ a.jsx(Be, { message: o, onDismiss: s, show: r, type: "error" });
};
function st(t = []) {
  return ({ allFileIds: e }) => ({
    allFileIds: [...e, ...t]
  });
}
function at(t = []) {
  return ({ pendingFileIds: e }) => ({
    pendingFileIds: [...e, ...t]
  });
}
function lt(t, e) {
  return ({ filesById: n }) => ({
    filesById: {
      ...n,
      ...t.reduce((i, r) => (i[r] = e[r], i), {})
    }
  });
}
function dt(t, e) {
  return (n) => ({
    ...st(t)(n),
    ...at(t)(n),
    ...lt(t, e)(n)
  });
}
function re(t) {
  return ({ pendingFileIds: e }) => ({
    pendingFileIds: e.filter((n) => n !== t)
  });
}
function ct(t) {
  return ({ allFileIds: e }) => ({
    allFileIds: e.filter((n) => n !== t)
  });
}
function ut(t) {
  return ({
    filesById: e
  }) => {
    const n = { ...e };
    return delete n[t], {
      filesById: n
    };
  };
}
function pt(t) {
  return ({
    progressByFileId: e
  }) => {
    const n = { ...e };
    return delete n[t], {
      progressByFileId: n
    };
  };
}
function Z(t) {
  return (e) => ({
    ...ut(t)(e),
    ...pt(t)(e),
    ...ct(t)(e),
    ...re(t)(e)
  });
}
function ft(t, e) {
  return ({
    filesById: n
  }) => ({
    filesById: {
      ...n,
      [e]: t
    }
  });
}
function mt(t, e) {
  return (n) => ({
    ...ft(e, t)(n),
    ...re(t)(n)
  });
}
function ht(t) {
  return () => ({
    failedFileIds: t
  });
}
function gt(t, e) {
  return ({
    progressByFileId: n
  }) => ({
    progressByFileId: {
      ...n,
      [t]: e === 100 ? void 0 : e
    }
  });
}
function yt(t) {
  const e = t.map(({ temporaryId: i }) => i), n = t.reduce((i, r) => (i[r.temporaryId] = r, i), {});
  return (i) => ({
    ...ht(e)(i),
    failuresByFileId: n,
    showErrors: !0
  });
}
const Ft = "/ajax/files/attachTemporary.php", bt = "upload", _t = "/files/post_upload_url";
class oe extends Error {
  constructor({ message: e, errorType: n }) {
    super(e), this.errorType = n;
  }
}
async function xt() {
  const { data: t } = await z.ajax.get(_t);
  return t;
}
async function wt(t, e) {
  try {
    const { url: n, fileInfo: i, formInputs: r } = await xt(), { additionalValues: s = {}, onUploadProgress: o } = e, l = new FormData();
    return Object.entries(r).forEach(([p, u]) => l.append(p, u)), Object.entries(s).forEach(([p, u]) => l.append(p, u)), l.append("x-amz-meta-file-name", encodeURIComponent(t.name)), l.append("file", t), await z.ajax.post(n, l, {
      onUploadProgress: (p) => {
        const u = Math.round(p.loaded * 100 / p.total);
        o == null || o(u);
      }
    }), {
      id: i,
      name: t.name,
      type: t.type,
      size: t.size
    };
  } catch {
    throw new oe({ errorType: "UPLOAD_FAILED", message: "Upload failed" });
  }
}
function It(t, e) {
  const { additionalValues: n = {}, name: i = bt, onUploadProgress: r, url: s = Ft } = e || {}, o = new FormData();
  return o.append(i, t), Object.keys(n).forEach((l) => o.append(l, n[l])), z.ajax.post(s, o, {
    onUploadProgress: (l) => {
      r(Math.round(l.loaded * 100 / l.total));
    }
  }).then(({ data: l }) => {
    const { errorType: p, fid: u, message: d, name: c, type: m, size: h, status: F } = l || {};
    if (F !== "OK")
      throw new oe({ message: d, errorType: p });
    return {
      id: u,
      name: c,
      type: m,
      size: h
    };
  });
}
class Kt extends fe {
  constructor(e) {
    super(e), this._removeFile = (r) => {
      const { onRemove: s = () => null } = this.props, { filesById: o, pendingFileIds: l = [] } = this.state;
      this.setState(Z(r)), g.includes(l, r) || s(o[r]);
    }, this._uploadFiles = (r) => {
      const { onChange: s = () => null, allowEncryptedPdfs: o = !0 } = this.props, l = Oe(r), p = Ne(r, l), u = De(r, l).filter((c) => !!c);
      this.setState(dt(u, p));
      const d = r.map(async (c) => {
        const m = l.get(c);
        return m && !o && c.type === "application/pdf" && await ze(c) ? this._handleUploadFailure({
          nativeFile: c,
          originalRejection: {
            message: "",
            errorType: "encrypted_pdf_not_allowed"
          },
          temporaryId: m
        }) : m ? this._startUpload(c, m) : Promise.reject();
      });
      s(r, d), this._handleUploadFailures(d);
    }, this._renameFile = (r, s) => {
      const { onRename: o, canRename: l } = this.props;
      o && l && o(r, (u) => {
        if (!u)
          return;
        const { filesById: d } = this.state;
        if (d[s]) {
          const c = { ...d[s], name: u }, m = { ...d, [s]: c };
          this.setState({
            filesById: m
          });
        }
      });
    }, this._handleUploadFailure = ({ nativeFile: r, originalRejection: s, temporaryId: o }) => {
      const { onError: l = () => null } = this.props;
      return this.setState(Z(o)), l(ie(r)), Promise.reject({ ...s, temporaryId: o, nativeFile: r });
    }, this._handleUploadFailures = async (r) => {
      const { hasCustomErrorHandler: s } = this.props, o = await Ue(r);
      o.length > 0 && !s && this.setState(yt(o));
    }, this._handleUploadProgress = (r, s) => {
      this.setState(gt(r, s));
    }, this._handleUploadSuccess = ({
      temporaryId: r,
      postUploadMetadata: s
    }) => {
      const { onUpload: o = () => null } = this.props, { pendingFileIds: l } = this.state;
      g.includes(l, r) && (this.setState(mt(r, s)), o(s));
    }, this._statusMessageId = g.uniqueId("file-upload-status-message-");
    const { initialFiles: n = [] } = e || {}, i = Pe(n);
    this.state = {
      allFileIds: Object.keys(i),
      failedFileIds: [],
      failuresByFileId: {},
      filesById: i,
      pendingFileIds: [],
      progressByFileId: {},
      showErrors: !1
    };
  }
  get _service() {
    const { endpoint: e } = this.props;
    return typeof e == "function" ? e : f.ifFeature("files_api_v2_enabled", wt, It);
  }
  _getServiceOptions(e) {
    const { additionalValues: n, endpoint: i } = this.props;
    let r;
    return typeof i == "string" ? r = i : typeof i == "object" && (r = i.url), {
      additionalValues: n,
      name: typeof i == "object" && i.name ? i.name : void 0,
      onUploadProgress: (s) => this._handleUploadProgress(e, s),
      url: r
    };
  }
  _startUpload(e, n) {
    return this._service(e, this._getServiceOptions(n)).then(
      (i) => this._handleUploadSuccess({
        postUploadMetadata: i,
        temporaryId: n
      }),
      (i) => this._handleUploadFailure({
        nativeFile: e,
        originalRejection: i,
        temporaryId: n
      })
    );
  }
  render() {
    const {
      acceptedTypes: e = [],
      ariaDescribedby: n,
      biId: i = "",
      canDragDrop: r = !1,
      canRename: s = !1,
      canSelectMultiple: o = !1,
      children: l,
      classes: p = {},
      errorMessage: u,
      fileDropperProps: d = {},
      inputRef: c,
      isDisabled: m = !1,
      isRequired: h,
      name: F,
      onBlur: C = g.noop,
      size: x = "medium",
      status: B,
      toggleRef: S,
      warningMessage: E
    } = this.props, { allFileIds: R, failuresByFileId: b, failedFileIds: I, filesById: U, pendingFileIds: D, progressByFileId: T, showErrors: N } = this.state, O = {
      acceptedTypes: e,
      allFileIds: R,
      ariaDescribedby: n,
      biId: i,
      canRename: s,
      canSelectMultiple: o,
      errorMessage: u,
      failedFileIds: I,
      filesById: U,
      inputRef: c,
      isDisabled: m,
      isRequired: h,
      name: F,
      onBlur: C,
      pendingFileIds: D,
      progressByFileId: T,
      removeFile: this._removeFile,
      renameFile: this._renameFile,
      status: B,
      statusMessageId: this._statusMessageId,
      toggleRef: S,
      upload: this._uploadFiles,
      warningMessage: E
    }, M = me.count(l) > 0 ? l : f.ifFeature(
      "encore",
      /* @__PURE__ */ a.jsxs(
        v,
        {
          "data-bi-id": i,
          "data-fabric-component": "FileUpload",
          display: "inline-block",
          minHeight: H[x],
          children: [
            /* @__PURE__ */ a.jsx(Y, {}),
            /* @__PURE__ */ a.jsx(V, {})
          ]
        }
      ),
      /* @__PURE__ */ a.jsx(
        Q,
        {
          className: p.root,
          "data-bi-id": i,
          "data-fabric-component": "FileUpload",
          display: "inline-flex",
          flexDirection: "column",
          minHeight: H[x],
          children: /* @__PURE__ */ a.jsxs(P, { children: [
            /* @__PURE__ */ a.jsx(Y, {}),
            /* @__PURE__ */ a.jsx(V, {})
          ] })
        }
      )
    );
    return /* @__PURE__ */ a.jsxs(A.Provider, { value: O, children: [
      r ? /* @__PURE__ */ a.jsx(
        he,
        {
          ...d,
          acceptedTypes: e,
          canSelectMultiple: o,
          onFileDrop: (j) => {
            var y;
            (y = d.onFileDrop) == null || y.call(d, j), this._uploadFiles(j);
          },
          permission: (o || R.length === 0) && d.permission !== !1,
          children: M
        }
      ) : M,
      /* @__PURE__ */ a.jsx(
        ot,
        {
          canSelectMultiple: o,
          failedFileIds: I,
          failuresByFileId: b,
          isVisible: N,
          onDismiss: () => this.setState({ showErrors: !1 })
        }
      )
    ] });
  }
}
export {
  Kt as F,
  V as I,
  Y as L,
  He as T,
  Ue as g
};
//# sourceMappingURL=file-upload-qEEuC7RE.mjs.map
